<template>
	<!-- 发票明细 -->
	<div class="page-container" id="invoiceDetailContainer">
    <el-row>
      <el-col>
        <el-button type="primary" size="small" plain @click="downloadAttachment()">下载附件</el-button>
      </el-col>
    </el-row>
		<el-form :model="invoiceDetailForm" ref="ruleFormRef" class="form-panel" label-position="left" :disabled="true">

			<el-row class="panel-top" type="flex" justify="space-between" align="top">
				<el-col :span="16" class="border-rang">
					<el-row type="flex" justify="start" align="top" :gutter="10">
						<el-col :span="2" class="flex-column border-right">
							<span class="span-column">购买方</span>
						</el-col>
						<el-col :span="22">
							<el-row type="flex" justify="start" align="top" :gutter="10">
								<el-col :span="12">
									<el-form-item label="发票抬头:">
										<el-col :span="17" style="float:right">
											<el-input size="mini" v-model="invoiceDetailForm.payeePayerName"></el-input>
										</el-col>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="结算对象:">
										<el-col :span="17" style="float:right">
											<el-input size="mini" v-model="invoiceDetailForm.settleCustName"></el-input>
										</el-col>
									</el-form-item>
								</el-col>
							</el-row>
							<el-row type="flex" justify="start" align="top" :gutter="10">
								<el-col :span="12">
									<el-form-item label="纳税人识别号:">
										<el-col :span="17" style="float:right">
											<el-input size="mini" v-model="invoiceDetailForm.taxpayerIdentificatioNo"></el-input>
										</el-col>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="发票类型:">
										<el-col :span="17" style="float:right">
											<el-input size="mini" v-model="invoiceDetailForm.invoiceType"></el-input>
										</el-col>
									</el-form-item>
								</el-col>
							</el-row>
							<el-row type="flex" justify="start" align="top" :gutter="10">
								<el-col :span="12">
									<el-form-item label="地址、电话:">
										<el-col :span="17" style="float:right">
											<el-input size="mini" v-model="invoiceDetailForm.csAddr" ></el-input>
										</el-col>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="发票号码:">
										<el-col :span="17" style="float:right">
											<el-input size="mini" v-model="invoiceDetailForm.invoiceNo"></el-input>
										</el-col>
									</el-form-item>
								</el-col>
							</el-row>
							<el-row type="flex" justify="start" align="top" :gutter="10">
								<el-col :span="12">
									<el-form-item label="开户银行及账号:">
										<el-col :span="17" style="float:right">
											<el-input size="mini" v-model="invoiceDetailForm.bankName"></el-input>
										</el-col>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="开票日期:">
										<el-col :span="17" style="float:right">
											<el-input size="mini" v-model="invoiceDetailForm.issuedDate"></el-input>
										</el-col>
									</el-form-item>
								</el-col>
							</el-row>
						</el-col>
					</el-row>
				</el-col>
				<el-col :span="8" style="width:31%" class="border-rang">
					<el-row type="flex" justify="start" align="top" :gutter="10">
						<el-col :span="3" class="flex-column border-right">
							<span class="span-column">基本信息</span>
						</el-col>
						<el-col :span="21">
							<el-row type="flex" justify="start" align="top" :gutter="10">
								<el-col :span="24">
									<el-form-item label="发票号:">
										<el-col :span="17" style="float:right">
											<el-input size="mini" v-model="invoiceDetailForm.invoiceNo"></el-input>
										</el-col>
									</el-form-item>
								</el-col>
							</el-row>
							<el-row type="flex" justify="start" align="top" :gutter="10">
								<el-col :span="24">
									<el-form-item label="发票代码:">
										<el-col :span="17" style="float:right">
											<el-input size="mini" v-model="invoiceDetailForm.invoiceCode"></el-input>
										</el-col>
									</el-form-item>
								</el-col>
							</el-row>
							<el-row type="flex" justify="start" align="top" :gutter="10">
								<el-col :span="24">
									<el-form-item label="账单号:">
										<el-col :span="17" style="float:right">
											<el-input size="mini" v-model="invoiceDetailForm.invoiceSerialNo"></el-input>
										</el-col>
									</el-form-item>
								</el-col>
							</el-row>
							<el-row type="flex" justify="start" align="top" :gutter="10" style="height:36.67px;">
								<el-col :span="24">
								</el-col>
							</el-row>
						</el-col>
					</el-row>
				</el-col>
			</el-row>
			<el-row class="panel-top" type="flex" justify="start" align="top">
				<el-col :span="24" class="border-rang">
					<el-row class="padding-rang">
						<el-col>
							<span>发票内容</span>
						</el-col>
					</el-row>
					<el-row class="padding-rang">
						<el-col>
							<hot-table
								ref="invoiceContentTableRef"
								:data-source="invoiceContentTableDataSource"
								:settings="invoiceContentTableSettings"
								col-settings-key="invoiceContentKey"
								@cellDblclick="invoiceContentTableCellClick"
								:rules="invoiceContentTableRules"
								>
								<hot-column :has-tip="true" data="freightName" title="费用名称"></hot-column>
								<hot-column :has-tip="true" data="standard" title="规则型号" ></hot-column>
								<hot-column :has-tip="true" data="unit" title="单位"></hot-column>
								<hot-column :has-tip="true" data="unitPrice" title="单价" ></hot-column>
								<hot-column :has-tip="true" data="quantity" title="数量" ></hot-column>
								<hot-column :has-tip="true" data="amount" title="金额" ></hot-column>
								<hot-column :has-tip="true" data="actualTaxRate" title="税率" ></hot-column>
								<hot-column :has-tip="true" data="actualTaxes" title="税金" ></hot-column>
								<!-- <hot-column :has-tip="true" data="detailActualTaxes" title="实际税金额" ></hot-column>
								<hot-column :has-tip="true" data="detailEstimatedAmount" title="本位币不含税金额" ></hot-column> -->
							</hot-table>
						</el-col>
					</el-row>
				</el-col>
			</el-row>
			<el-row class="panel-top" type="flex" justify="start" align="top">
				<el-col :span="8">
					<el-form-item label="实际税金额:">
						<el-col :span="17" style="float:right">
							<el-input size="mini" v-model="invoiceDetailForm.actualTaxes"></el-input>
						</el-col>
					</el-form-item>
				</el-col>
				<el-col :span="8" :offset="1">
					<el-form-item label="本位币不含税金额:">
						<el-col :span="17" style="float:right">
							<el-input size="mini" v-model="invoiceDetailForm.estimatedAmount"></el-input>
						</el-col>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row class="panel-top border-rang" type="flex" justify="space-between" align="top">
				<el-col :span="16">
					<el-row type="flex" justify="start" align="top" :gutter="10">
						<el-col :span="2" class="flex-column border-right">
							<span class="span-column">销售方</span>
						</el-col>
						<el-col :span="22">
							<el-row type="flex" justify="start" align="top" :gutter="10">
								<el-col :span="12">
									<el-form-item label="名称:">
										<el-col :span="17" style="float:right">
											<el-input size="mini" v-model="invoiceDetailForm.settleOfficeName"></el-input>
										</el-col>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="纳税人识别号:">
										<el-col :span="17" style="float:right">
											<el-input size="mini" v-model="invoiceDetailForm.businessRegisterNo"></el-input>
										</el-col>
									</el-form-item>
								</el-col>
							</el-row>
							<el-row type="flex" justify="start" align="top" :gutter="10">
								<el-col :span="12">
									<el-form-item label="电话、地址:">
										<el-col :span="17" style="float:right">
											<el-input size="mini" v-model="invoiceDetailForm.telAndAdress"></el-input>
										</el-col>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="开户银行及账号:">
										<el-col :span="17" style="float:right">
											<el-input size="mini" v-model="invoiceDetailForm.bankNameAndAccount"></el-input>
										</el-col>
									</el-form-item>
								</el-col>
							</el-row>
						</el-col>
					</el-row>
				</el-col>
				<el-col :span="8" style="padding: 0px 8px 8px 8px">
					<el-form-item label="备注:">
							<el-input
							size="mini"
							type="textarea"
							:rows="3" v-model="invoiceDetailForm.invoiceRemark">
						</el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row class="panel-top" type="flex" justify="start" align="top">
				<el-col :span="8">
					<el-form-item label="收款人:">
						<el-col :span="17" style="float:right">
							<el-input size="mini" v-model="invoiceDetailForm.payeePayerName"></el-input>
						</el-col>
					</el-form-item>
				</el-col>
				<el-col :span="8" :offset="1">
					<el-form-item label="复核:">
						<el-col :span="17" style="float:right">
							<el-input size="mini" v-model="invoiceDetailForm.checkPersonName"></el-input>
						</el-col>
					</el-form-item>
				</el-col>
				<el-col :span="8" :offset="1">
					<el-form-item label="开票人:">
						<el-col :span="17" style="float:right">
							<el-input size="mini" v-model="invoiceDetailForm.drawerName"></el-input>
						</el-col>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
	</div>
</template>

<script>
	import { queryInvoice,downloadInvoice } from "@/api/queryMainSystem";
	export default {
		name: "InvoiceDetail",
		data() {
			return {
			  invoiceUrl: '',
				invoiceDetailForm: {

				},
				// 发票内容
				invoiceContentTableDataSource: [],
				invoiceContentTableSettings: {
					height: 200,
					autoColumnSize: true,
					stretchH: 'none', // 根据宽度横向扩展，last:只扩展最后一列，none：默认不扩展
					...this.$systemConfig.tableConfig,
				},
				invoiceContentTableRules: {

				},
			};
		},
    async created() {

			let self = this
			if(self.$route.params && self.$route.params.ebInvoiceId) {
				self.queryInvoiceDetail(self.$route.params.ebInvoiceId)
			}
		},
		mounted() {
			let self = this
			console.log(self.$route)

			// 监听外层容器div宽度的变化，做表格自适应
			self.resizeObserver = new ResizeObserver(entries => {
				self.$nextTick(() => {
					self.$refs.invoiceContentTableRef.resizeTo(entries[0].target.clientWidth - 32)
				})
			})
			self.resizeObserver.observe(document.getElementById("invoiceDetailContainer"))
		},
		methods: {
			downloadAttachment() {
        let self = this;
        downloadInvoice(self.invoiceUrl).then(res => {
          if(res.success) {
            self.$coreMethods.message("info", "开始下载");
          }else{
            self.$coreMethods.message("error", "下载失败");
          }
        });
			},
			queryInvoiceDetail(id) {
				let self = this;
				let data = {
					bcInvoiceId: id,
					isDetail: 'Y'
				}
				queryInvoice(data).then(res => {
					if(res.success) {
						res.records.records[0].telAndAdress = res.records.records[0].tel + '/' + res.records.records[0].addressCn
						res.records.records[0].bankNameAndAccount = res.records.records[0].bankName + '/' + res.records.records[0].bankAccount
						self.invoiceDetailForm = Object.freeze(res.records.records[0])
						self.invoiceUrl = res.records.records[0].invoiceUrl
						self.invoiceContentTableDataSource = Object.freeze(res.records.records[0].bcInvoiceContents)
					} else {
						self.$coreMethods.message("error", "查询失败");
					}
				})
			}
		}
	};
</script>

<style scoped lang="scss">
	::v-deep .el-form-item__label {
		line-height: 36px !important;
	}
</style>
